import React from 'react'
import Link from 'gatsby-link'
import { Info, ChevronDown, ChevronUp } from 'react-feather'
import styled from 'styled-components'
import logo from '../static/images/logo.gif'

const HeaderWrapper = styled.div`
  height: 100%;
  margin: 0 auto;
  margin-bottom: -20px;
`
const HeaderContent = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 960px;
  height: 100%;
  margin: 0 auto;
  img {
    max-width: 250px;
  }
`

const MainNav = styled.nav`
  background: #cccccc;
  div {
    display: none;
    justify-content: center;
    cursor: pointer;
    font-size: 1.2rem;
    background: #b6b6b6;
    margin-bottom: 2px;
    padding: 0.2rem 0;
    @media (max-width: 960px) {
      display: flex;
    }
  }
  ul {
    list-style-type: none;
    display: flex;
    padding: 0;
    margin: 0;
    @media (max-width: 960px) {
      flex-direction: column;
      transition: max-height 0.6s ease-in-out;
      &.active {
        max-height: 5000px;
      }
      &.inactive {
        max-height: 0;
        overflow: hidden;
      }
    }
    li {
      margin: 2px 1px;
      flex: 1;
      display: flex;
      transition: all 0.5s;
      padding: 0;
      a {
        text-decoration: none;
        background: #b6b6b6;
        color: #373435;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0rem 1.618rem;
        width: 100%;
        height: 2rem;
        transition: background 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
        &:hover {
          background: #ccc;
        }
        @media (max-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }
  }
`

const LogoArea = styled.div`
  display: flex;
  padding: 1.236rem 0.764rem;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const AttentionButton = styled.a`
  display: flex;
  background: #e2e2e2;
  cursor: pointer;
  padding: 0.3rem;
  font-size: 1.2rem;
  border-radius: 100px;
  text-decoration: none;
  color: #373435;
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
`

class Header extends React.Component {
  constructor() {
    super()
    this.state = {
      active: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.collapseMenu = this.collapseMenu.bind(this)
  }

  toggleMenu() {
    const active = this.state.active
    this.setState({ active: !active })
  }

  collapseMenu() {
    this.setState({ active: false })
  }

  render() {
    return (
      <HeaderWrapper>
        <HeaderContent>
          <LogoArea>
            <img src={logo} alt="Gasred Logo" />
            <AttentionButton
              href="http://189.198.236.146/cgwatio/default.aspx"
              target="_blank"
            >
              <Info />Atención a clientes
            </AttentionButton>
          </LogoArea>
          <MainNav>
            <div
              onClick={() => {
                this.toggleMenu()
              }}
            >
              Menú<ChevronDown
                style={{ display: `${!this.state.active ? '' : 'none'}` }}
              />
              <ChevronUp
                style={{ display: `${this.state.active ? '' : 'none'}` }}
              />
            </div>
            <ul className={`${this.state.active ? 'active' : 'inactive'}`}>
              <li>
                <Link
                  to="/"
                  onClick={() => {
                    this.collapseMenu()
                  }}
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/quienes-somos"
                  onClick={() => {
                    this.collapseMenu()
                  }}
                >
                  Quienes Somos
                </Link>
              </li>
              <li>
                <Link
                  to="/gasred"
                  onClick={() => {
                    this.collapseMenu()
                  }}
                >
                  Sistema Gasred
                </Link>
              </li>
              <li>
                <Link
                  to="/ubicaciones"
                  onClick={() => {
                    this.collapseMenu()
                  }}
                >
                  Ubicaciones
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto"
                  onClick={() => {
                    this.collapseMenu()
                  }}
                >
                  Contacto
                </Link>
              </li>
            </ul>
          </MainNav>
        </HeaderContent>
      </HeaderWrapper>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js